unit smx.webcore.types;

interface

uses
{$IFDEF PAS2JS}
  Generics.Collections;
{$ELSE}
  System.Generics.Collections;
{$ENDIF}

type

  TSortDirection = (sdAsc, sdDesc);
  TSortPair = TPair<integer, TSortDirection>;
  TRefStatus = (RefEmpty, RefNotChecked, RefChecking, RefUnique, RefInUse);
  TViewOption = (voNone, voReadOnly, voEdit, voCreateAndEdit);
  TValueChangeState = (vcsNoChange, vcsValid, vcsInvalid);

const
  POPUP_FORM_CLASS = 'PopUpForm';

implementation

end.
